import React from "react";

type ITab = {
  value: string;
};

const Tab: React.FC<ITab> = ({ value }) => {
  return (
    <div className="px-3 py-1 bg-customgreen rounded-md text-xs font-medium text-primary-800">
      {value}
    </div>
  );
};

export default Tab;
